const navs = [
  {
    title: 'reports',
    type: 'group',
    icon: 'mdi-chart-bar',
    color: '#3e6187',
    access: 'reports',
    items: [
      {title: 'sales_summary', link: '/reports/summary', access: 'report_sale'},
      {title:'material_report',link:'/material/report',access:'material_report'},
      {title: 'report_account', link: '/reports/consumption', access: 'report_accaunt'},
      // {title: 'abc_analysis', link: '/reports/abc', access: 'report_abs'},
      {title: 'sales_by_item', link: '/reports/by/item', access: 'report_sale_by_item'},
      {title: 'sales_by_category', link: '/reports/by/category', access: 'report_sale_by_category'},
      {title: 'sales_by_supplier', link: '/reports/by/supplier', access: 'report_sale_by_supplier'},
      // {title: 'supplier_view', link:'/reports/by/supplier-view'},
      {title: 'sales_by_employee', link: '/reports/by/employee', access: 'report_employee'},
      {title: 'sales_by_payment', link: '/reports/by/payment_type', access: 'report_sale_by_payment'},
      // { title: 'sales_by_modifier', link: '/reports/by/modifier' },
      {title: 'receipts', link: '/reports/receipts', access: 'report_receipt'},
      {title: 'debts', link: '/reports/debts', access: 'report_debt'},
      {title: 'discounts', link: '/reports/discounts', access: 'report_discount'},
      {title: 'taxes', link: '/reports/taxes', access: 'report_taxes'},
      {title: 'shifts', link: '/reports/shifts', access: 'report_shift'},
      // { title: 'workgroup_orders', link: '/reports/workgroup-orders' },
      // { title: 'workgroup_orders_report', link: '/reports/workgroup-orders-each' },
      // { title: 'workgroup_orders_report_by_employee', link: '/reports/workgroup-report-by-employee' },
      //{ title: 'reports_safe', link: '/reports/safe' },
    ]
  },
  {
    title: 'items',
    type: 'group',
    icon: 'mdi-basket',
    color: '#EC407A',
    access: 'items',
    items: [
      {title: 'item_list', link: '/items/list', access: 'item_list'},
      {title: 'mxik_search', link: '/mxik/search', access: 'item_mxik_search'},
      {title: 'composite_item', link: '/items/lists/composite', access: 'item_composite_item'},
      //{ title: 'online_store', link: '/items/lists/store' },
      {title: 'add_from_warehause', link: '/items/add-global', access: 'item_add_from_warehause'},
      {title: 'print_labels', link: '/items/create-label/label', access: 'item_print_label'},
      {title: 'item_mark', link: '/items/mark', access: 'item_mark'},
      {title: 'item_price_change_history', link: '/items/history/price_change', access: 'item_price_change_history'},
      // { title: 'tech_map', link: '/items/tech-map' },
      {title: 'categories', link: '/items/categories', access: 'item_categories'},
      {title: 'modifiers', link: '/items/modifiers', access: 'item_modifiers'},
      {title: 'discounts', link: '/items/discounts', access: 'item_discount'},
      {title: 'promotions_and_discounts', link: '/items/promotions'}
    ]
  },
  {
    title: 'inventory_management',
    type: 'group',
    icon: 'mdi-cart',
    color: '#039BE5',
    access: 'inventory',
    items: [
      {title: 'purchase_orders', link: '/inventory/purchase', access: 'inv_purchase_orders'},
      // { title: 'receipts', link: '/reports/receipts' },
      {title: 'purchase_mark', link: '/inventory/purchase_mark', access: 'inv_purchase_mark'},
      //      { title: 'online_kassa', link: '/inventory/sale', },
      {title: 'purchase_employee', link: '/purchase/employee'},
      {title: 'transfer_orders', link: '/inventory/transfer', access: 'inv_transfer_orders'},
      {title: 'stock_adjusment', link: '/inventory/stock', access: 'inv_stock_adjusment'},
      {title: 'inventory_counts', link: '/inventory/counts', access: 'inv_inventory_counts'},
      {title: 'productions', link: '/inventory/productions', access: 'inv_productions'},
      {title: 'suppliers', link: '/inventory/suppliers', access: 'inv_suppliers'},
      {title: 'supplier_transaction', link: '/inventory/supplier/transactions', access: 'inv_supplier_transaction'},
      {title: 'fees', link: '/inventory/fees', access: 'inv_fees'},
      {title: 'inventory_history', link: '/inventory/history', access: 'inv_inventory_history'},
      {title: 'inventory_valuation', link: '/inventory/valuation', access: 'inv_inventory_valuation'},
      {title: 'supplier_valuation', link: '/inventory/supplier/valuation', access: 'inv_supplier_valuation'},
      {title: 'partition_valuation', link: '/partition/valuation', },
      {title: 'partition_item', link: '/partition/item', },
      // {title: 'inventory_history_report', link: '/inventory/report', access: 'inv_inventory_history'},
      // { title: 'receipts', link: '/inventory/receipts' },
    ]
  },
  // {
  //   title: 'workgroup', type: 'group', icon: 'mdi-file-tree', color: 'red',
  //   items: [
  //     { title: 'workgroup_orders', link: '/inventory/workgroup/orders' },
  //     { title: 'workgroup', link: '/employees/workgroup' },
  //     { title: 'workgroup_comments', link: '/workgroup/workgroup_comments' },
  //     { title: 'task', link: '/employees/task' }
  //   ]
  // },
  {
    title: 'employees',
    type: 'group',
    icon: 'mdi-account-card-details',
    color: '#3e6187',
    access: 'employees',
    items: [
      {title: 'employee_list', link: '/employees/list', access: 'employee_list'},
      {title: 'access_rights', link: '/employees/access', access: 'employee_access_rights'},
      {title: 'timecards', link: '/employees/timecards', access: 'employee_time_cards'},
      {title: 'total_hours_worked', link: '/employees/worked', access: 'employee_total_worked'},
    ]
  },
  {title: 'customers', type: 'item', link: '/customers', icon: 'mdi-account-multiple', color: '#5C6BC0', access: 'customers'},
  {
    title: 'settings', type: 'group', icon: 'mdi-settings', color: '#607D8B',
    access: 'settings',
    items: [
      {title: 'general', link: '/settings/general', access: 'setting_general'},
      {title: 'organization', link: '/settings/organization', access: 'setting_organization'},
      {title: 'nds', link: '/settings/nds', access: 'setting_nds'},
      {title: 'payment_types', link: '/settings/payment', access: 'setting_payment_types'},
      {title: 'currency', link: '/settings/currency', access: 'setting_currency'},
      {title: 'loyalty', link: '/settings/loyalty', access: 'setting_loyalty'},
      {title: 'taxes', link: '/settings/taxes', access: 'setting_taxes'},
      {title: 'receipt', link: '/settings/receipt', access: 'setting_receipt'},
      // { title: 'open_tickets', link: '/settings/tickets', access: 'setting_open_tickets' },
      // { title: 'buttons', link: '/settings/buttons', access: 'setting_buttons' },
      // { title: 'options', link: '/settings/options', access: 'setting_options' },
      // { title: 'kitchen_printers', link: '/settings/printers' },
      {title: 'stores', link: '/settings/stores', access: 'setting_stores'},
      {title: 'pos_devices', link: '/settings/devices', access: 'setting_pos_devices'},
      // {title: 'client_status', link: '/settings/client/status'}
    ]
  }
]
import Userable from "../../mixins/userable"
export default {
  mixins: [Userable],
  navs
}
